<template>
    <div>
        <div class=" uk-section uk-padding-remove-vertical">
            <div id="scene2">
                <div id="particle" data-depth="0.1"></div>
            </div>
            <!-- TOP -->
            <div class="top-wrap uk-position-relative " style="min-height: 100vh;">
                <img class="logo" src="../assets/img/biff.svg" alt="">
                <div id="scene" class="uk-cover-container uk-flex uk-flex-middle top-wrap-height">

                    <!-- TOP CONTAINER -->
                    <div data-depth="0.1"
                         class=" hero uk-container uk-flex-auto top-container uk-position-relative uk-margin-medium-top uk-margin-bottom">
                        <div class="uk-width-1-1@s  uk-text-center"
                             uk-scrollspy="cls: uk-animation-slide-right-medium; target: > *; delay: 150">
                            <h1 class="uk-margin-remove-top">Suite aux r&eacute;cents &eacute;v&egrave;nements, l'&eacute;dition 2020 du BIFF est annul&eacute;e.</h1>
                            <h3>Pour toute question : contact@biff2020.com</h3>
                            <p></p>
                            <p></p>
                        </div>

                    </div>
                    <!-- /TOP CONTAINER -->
                    <!-- TOP IMAGE -->

                    <!-- /TOP IMAGE -->
                </div>

            </div>
            <!-- /TOP -->
        </div>
        <!-- JS FILES -->
    </div>
</template>

<script>
    import Parallax from 'parallax-js';

    export default {
        data() {
            return {}
        },
        watch: {},
        computed: {},
        components: {},
        created: function () {

        },
        mounted: function () {

            var scene = document.getElementById('scene');
            new Parallax(scene, {
                hoverOnly: true,
                relativeInput: true
            });
            var scene2 = document.getElementById('scene2');
            new Parallax(scene2, {

                relativeInput: true
            });

        },
        methods: {},
        name: 'BiffTheEnd'
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
